<template>
  <div class="rcs-step rcs-step--representative">
    <h2 class="rcs-step__heading">
      {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.title') }}
    </h2>
    <p class="rcs-step__lead">
      {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.subtitle') }}
    </p>

    <div class="rcs-form-grid">
      <div class="rcs-form-grid__field">
        <label for="rcs-rep-first-name">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.fields.firstName') }}
        </label>
        <p class="rcs-form-grid__description">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.descriptions.firstName') }}
        </p>
        <InputText
          id="rcs-rep-first-name"
          v-model="form.representative.first_name"
          :maxlength="nameMaxLength"
        />
      </div>

      <div class="rcs-form-grid__field">
        <label for="rcs-rep-last-name">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.fields.lastName') }}
        </label>
        <p class="rcs-form-grid__description">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.descriptions.lastName') }}
        </p>
        <InputText
          id="rcs-rep-last-name"
          v-model="form.representative.last_name"
          :maxlength="nameMaxLength"
        />
      </div>

      <div class="rcs-form-grid__field rcs-form-grid__field--full">
        <label for="rcs-rep-email">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.fields.email') }}
        </label>
        <p class="rcs-form-grid__description">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.descriptions.email') }}
        </p>
        <InputText
          id="rcs-rep-email"
          v-model="form.representative.email"
          type="email"
          autocomplete="email"
        />
      </div>

      <div class="rcs-form-grid__field rcs-form-grid__field--full">
        <label for="rcs-rep-brand-website">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.fields.brandWebsite') }}
        </label>
        <p class="rcs-form-grid__description">
          {{ t('storeParameters.services.rcsServiceParameter.wizard.representative.descriptions.brandWebsite') }}
        </p>
        <InputText
          id="rcs-rep-brand-website"
          v-model="form.representative.brand_website"
          type="url"
          :placeholder="t('storeParameters.services.rcsServiceParameter.wizard.representative.placeholders.brandWebsite')"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import { RCS_REPRESENTATIVE_NAME_MAX_LENGTH } from '@/types/rcs-onboarding';
import type { RcsDedicatedFormState } from '@/types/rcs-onboarding';

export default defineComponent({
  name: 'RcsRepresentativeStep',

  components: { InputText },

  props: {
    form: {
      type: Object as PropType<RcsDedicatedFormState>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return {
      t,
      nameMaxLength: RCS_REPRESENTATIVE_NAME_MAX_LENGTH,
    };
  },
});
</script>
